module.exports = __webpack_public_path__ + "img/wsj_logo.6d3d40b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/wsj_logo.svg
// module id = ./assets/img/media/wsj_logo.svg
// module chunks = 0 12